import { useState, useEffect, useCallback } from "react";
import { collection, getDocs, query, where, orderBy } from "firebase/firestore";
import { db } from "../../../../services/firebase";
import { COLLECTIONS } from "../../../../services/collections";
import { useTenant } from "../../../../hooks/useTenant";

/**
 * Hook para buscar o histórico de snapshots de performance de um colaborador específico.
 * Retorna os últimos 12 meses de snapshots ordenados por período.
 */
export const useEmployeeHistory = (employeeId) => {
    const { idTenant } = useTenant();
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchHistory = useCallback(async () => {
        if (!idTenant || !employeeId) return;
        setLoading(true);

        try {
            const q = query(
                collection(db, "tenants", idTenant, COLLECTIONS.PERFORMANCE_SNAPSHOTS),
                where("idEmployee", "==", employeeId),
                where("periodType", "==", "monthly"),
                orderBy("period", "asc")
            );

            const snap = await getDocs(q);
            const data = snap.docs.map(d => ({ id: d.id, ...d.data() }));

            // Pegar os últimos 12
            setHistory(data.slice(-12));
        } catch (error) {
            console.error("[useEmployeeHistory] Erro ao buscar histórico:", error);
            setHistory([]);
        } finally {
            setLoading(false);
        }
    }, [idTenant, employeeId]);

    useEffect(() => {
        fetchHistory();
    }, [fetchHistory]);

    return { history, loading };
};
